/* acaciasupplies — plates.js
   Una sola tarea: encender el botón "Print data sheet" de la ficha y llamar
   a window.print(). Sin dependencias.

   Por qué el botón nace oculto: `window.print()` es lo único que este botón
   hace, así que sin JavaScript no haría nada. Un botón muerto es peor que un
   botón que no está. La hoja en sí no depende de esto: es
   `assets/print-datasheet.css` con `media="print"`, y quien imprima con
   Ctrl+P obtiene exactamente lo mismo sin tocar el botón. */
(function () {
  'use strict';

  var button = document.querySelector('[data-print-sheet]');
  if (!button || typeof window.print !== 'function') return;

  button.removeAttribute('hidden');

  button.addEventListener('click', function () {
    window.print();
  });
})();
